export const setMeta = () => {
    const meta1 = document.createElement('meta')
    meta1.setAttribute('name', 'apple-mobile-web-app-capable')
    meta1.setAttribute('content', 'yes')
    const meta2 = document.createElement('meta')
    meta2.setAttribute('name', 'viewport')
    meta2.setAttribute('content', 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no')
    document.head.appendChild(meta1)
    document.head.appendChild(meta2)
  }